import { Box, Button, Divider, Paper, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import Highcharts from "highcharts";
import NoRecordFound from "../../utils/NoRecordFound";

const BarChart = (Props) => {
  const handleViewChart3 = () => {
    Props.setIsFullScreen(true);
  };

  useEffect(() => {
    if (Props.data && Props.data.length > 0) {
      const combinedCounts = Props.data.map((item) => ({
        ...item,
        name: item.name,
        count: item.open_count + item.close_count,
      }));

      const sortedByCombinedCount = combinedCounts
        .slice()
        .sort((a, b) => b.count - a.count);
      const top5CombinedCount = sortedByCombinedCount.slice(0, 5);
      const categories = top5CombinedCount.map((item) => item.name);

      let open_report = [];
      let close_report = [];
      top5CombinedCount.map((item) => {
        open_report.push(item.open_count);
        close_report.push(item.close_count);
      });

      const BarChartData = {
        chart: {
          type: "bar",
          height: 500,
        },
        title: {
          text: "",
        },
        exporting: false,
        xAxis: {
          categories: categories,
        },
        yAxis: {
          min: 0,
          title: {
            text: "",
          },
        },
        credits: {
          enabled: false,
        },
        legend: {
          reversed: true,
        },
        plotOptions: {
          series: {
            stacking: "normal",
          },
        },
        series: [
          {
            name: "Open",
            data: open_report,
            color: "#7A5DF8",
            marker: {
              symbol: "circle",
            },
          },
          {
            name: "Close",
            data: close_report,
            color: "#F65464",
            marker: {
              symbol: "circle",
            },
          },
        ],
      };

      Highcharts.chart("BarChart", BarChartData);
    }
  }, [Props.data]);

  return (
    <>
      <Paper sx={{ borderRadius: "12px", height: "100%" }}>
        <Box sx={{ padding: "20px", height: "42rem" }}>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Box>
              <Typography
                sx={{ fontWeight: "600", fontSize: "17px", color: "#464E5F" }}
              >
               Vessel Wise Defects
              </Typography>
            </Box>
            <Box>
              <Button
                disabled={Props.data && Props.data.length > 0 ? false : true}
                sx={{
                  fontSize: "15px",
                  fontWeight: 600,
                  border: "1px solid #E5F1EB",
                  backgroundColor: "#E5F1EB",
                  padding: "8px 15px 5px 15px",
                  borderRadius: "10px",
                  textTransform: "capitalize",
                  color: "#20724E",
                  ":hover": {
                    backgroundColor: "#E5F1EB",
                  },
                }}
                onClick={handleViewChart3}
              >
                View All
              </Button>
            </Box>
          </Box>
          <Divider sx={{ margin: "20px 0" }} />
          <Box>
            {Props.data && Props.data.length > 0 ? (
              <div id="BarChart" style={{ width: "100%", height: "480px" }}>
                {/* Your Bar Chart content */}
              </div>
            ) : (
              <NoRecordFound />
            )}
          </Box>
        </Box>
      </Paper>
    </>
  );
};

export default BarChart;
